<template>
  <Modal
  :value="() => {}"
  :onClose="() => {}"
  :close="false"
  title="Pagamento com cartão"
  >
    <b-row class="form-group center">
      <b-col sm="12">
        <p>A transação foi enviada para o POS</p>
        <p><b>POS Stone > Pagamento</b><br>Aguardando o pagamento no POS...</p>
      </b-col>
    </b-row>
    <b-row class="form-group center">
      <b-col>
        <Button type="success" @click="handleConsultTransaction()">Transação Concluída</Button>
      </b-col>
    </b-row>
    <b-row class="form-group center">
      <b-col>
        <Button type="default" @click="handleCancelTransaction()">Cancelar Transação</Button>
      </b-col>
    </b-row>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { Button } from '@/components/Form';

export default {
  name: 'ModalTEFStone',
  components: {
    Modal,
    Button,
  },
  props: {
    consultTransaction: {
      type: Function,
      required: true,
    },
    cancelTransaction: {
      type: Function,
      required: true,
    },
  },
  methods: {
    async handleConsultTransaction() {
      return this.consultTransaction();
    },
    async handleCancelTransaction() {
      return this.cancelTransaction();
    },
  },
};
</script>

<style>
  .center {
    text-align: center!important;
  }
</style>
